module.exports = __webpack_public_path__ + "img/icon_box_2_3.898895a5.png";